import { GridFilterOperators } from '@progress/kendo-react-grid';

const text = [
    { text: "grid.filterContainsOperator", operator: 'contains' },
    { text: "grid.filterEqOperator", operator: 'eq' },
    { text: "grid.filterNotEqOperator", operator: 'neq' },
    { text: "grid.filterStartsWithOperator", operator: 'startswith' },
    { text: "grid.filterEndsWithOperator", operator: 'endswith' },
];

const numeric = [
    { text: "grid.filterEqOperator", operator: 'eq' },
    { text: "grid.filterGtOperator", operator: 'gt' },
    { text: "grid.filterGteOperator", operator: 'gte' },
    { text: "grid.filterLtOperator", operator: 'lt' },
    { text: "grid.filterLteOperator", operator: 'lte' },
];

const date = [
    { text: "grid.filterEqOperator", operator: 'eq' },
    { text: "grid.filterGtOperator", operator: 'gt' },
    { text: "grid.filterGteOperator", operator: 'gte' },
    { text: "grid.filterLtOperator", operator: 'lt' },
    { text: "grid.filterLteOperator", operator: 'lte' },
];

const boolean = [
    { text: "grid.filterEqOperator", operator: 'eq' }
];

export const filterOperators : GridFilterOperators  = {
    text,
    numeric,
    date,
    boolean
};